module.exports = __webpack_public_path__ + "img/flowImgs.a8f04ab3.png";